export default "__VITE_ASSET__C4Wb5r$Y__"